export default __webpack_public_path__ + "static/media/download.421fda75.svg";